const UserAuditLogs = () => {
	return <div>UserAuditLogs</div>;
};

export default UserAuditLogs;
